// @flow
import moment from 'moment'

const DATE_FORMAT_DISPLAY_MOMENTJS = 'DD-MM-YYYY'
const DATE_FORMAT_STORE_MOMENTJS = 'YYYY-MM-DD'
const DATE_FORMAT_DEEPLINK_DISPLAY_MOMENTJS = 'DD-MM-YYYY'
const DATE_FORMAT_DEEPLINK_STORE_MOMENTJS = 'YYYY-MM-DD'
const DATE_FORMAT_ZONE_MAP_MOMENTJS = 'YYYY-MM-DD'
const DATE_FORMAT_PRODUCTS_API_MOMENTJS = 'YYYY-MM-DD'
const DATE_FORMAT_ORDER_API_MOMENTJS = 'YYYY-MM-DD'

const formatDate = (date: ?Date, format: string): string => {
  if (!(date instanceof Date)) {
    return ''
  }
  return moment(date).format(format)
}
const parseDate = (formattedDate: string, format: string): ?Date => {
  const momentDate = moment(formattedDate, format, true)
  if (momentDate.isValid()) {
    return momentDate.toDate()
  }
  return null
}

const formatDisplayDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_DISPLAY_MOMENTJS)
}
const formatStoreDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_STORE_MOMENTJS)
}
const formatProductsApiDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_PRODUCTS_API_MOMENTJS)
}
const formatOrderApiDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_ORDER_API_MOMENTJS)
}
const formatZoneMapDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_ZONE_MAP_MOMENTJS)
}
const formatDeeplinkDate = (date: ?Date): string => {
  return formatDate(date, DATE_FORMAT_DEEPLINK_DISPLAY_MOMENTJS)
}
const parseDisplayDate = (formattedDate: string): ?Date => {
  return parseDate(formattedDate, DATE_FORMAT_DISPLAY_MOMENTJS)
}
const parseDeeplinkDate = (formattedDate: string): ?Date => {
  return (parseDate(formattedDate, DATE_FORMAT_DEEPLINK_DISPLAY_MOMENTJS) || parseDate(formattedDate, DATE_FORMAT_DEEPLINK_STORE_MOMENTJS))
}
const parseStoreDate = (formattedDate: string): ?Date => {
  return parseDate(formattedDate, DATE_FORMAT_STORE_MOMENTJS)
}
const parseOrderApiDate = (formattedDate: string): ?Date => {
  return parseDate(formattedDate, DATE_FORMAT_ORDER_API_MOMENTJS)
}
const constrainDate = (date: Date, minDate: Date, maxDate: ?Date): Date => {
  if (moment(date).isBefore(minDate)) {
    date = minDate
  }

  if (maxDate && moment(date).isAfter(maxDate)) {
    date = maxDate
  }

  return date
}

export {
  formatDisplayDate,
  formatStoreDate,
  formatProductsApiDate,
  formatZoneMapDate,
  formatOrderApiDate,
  formatDeeplinkDate,
  parseDisplayDate,
  parseStoreDate,
  parseDeeplinkDate,
  parseOrderApiDate,
  constrainDate
}



// WEBPACK FOOTER //
// ./src/utils/date.js